import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export const FAQS = [
  {
    q: "Is the preview really free?",
    a: "Yes. No cost, no obligation, no card required.",
  },
  {
    q: "Do I need to be tech-savvy?",
    a: "No. I handle setup, hosting, and updates. You text me changes.",
  },
  {
    q: "Will texts come from my business number?",
    a: "Messages send from a dedicated business line set up for you, registered with the carriers so they deliver reliably.",
  },
  {
    q: "How long does it take?",
    a: "Usually under two weeks from the day you approve the design.",
  },
  {
    q: "Do I own my website and domain?",
    a: "Yes. The domain is registered in your name and the site is yours.",
  },
  {
    q: "Am I locked into a contract?",
    a: "No long-term contract. Cancel the monthly care plan anytime. Hosting and maintenance continue through the end of your current paid billing period.",
  },
];

export default function FaqSection() {
  return (
    <Accordion
      type="single"
      collapsible
      className="mt-10"
      data-testid="faq-accordion"
    >
      {FAQS.map((f, i) => (
        <AccordionItem
          key={f.q}
          value={`faq-${i}`}
          data-testid={`faq-accordion-item-${i + 1}`}
          className="border-slate-200"
        >
          <AccordionTrigger className="py-5 text-left font-display text-base font-bold text-navy hover:no-underline sm:text-lg">
            {f.q}
          </AccordionTrigger>
          <AccordionContent className="pb-5 text-slate-600">
            {f.a}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
